<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    isLiked: boolean
    likeCount?: number
    loading?: boolean
    activeColorClass?: string
    inactiveColorClass?: string
    iconClasses?: string
  }>(),
  {
    loading: false,
    activeColorClass: 'tw-text-riser-blue',
    inactiveColorClass: 'tw-text-black/30'
  }
)

const emit = defineEmits(['click', 'countClick'])

const authStore = useAuthStore()
const route = useRoute()
const router = useRouter()

const click = () => {
  if (!authStore.session_data.user) {
    router.push({ path: '/getstarted', query: { r: route.fullPath } })
    return
  }

  emit('click')
}

const countClick = () => {
  emit('countClick')
}
</script>

<template>
  <InputAppButton
    :loading="props.loading"
    class="tw-inline-flex tw-items-center tw-gap-2"
    data-testid="like-button"
  >
    <IconsFlame
      :class="[
        props.isLiked ? props.activeColorClass : props.inactiveColorClass,
        props.iconClasses
      ]"
      @click="click"
    />

    <!-- pt-1 is to visually align the text with the flame icon -->
    <div v-if="props.likeCount" class="tw-pt-1 tw-leading-none" @click="countClick">
      <span class="tw-font-bold">
        {{ formatUserNumber(props.likeCount) }}
      </span>

      <span class="tw-opacity/70">
        {{ $t('%d people like this') }}
      </span>
    </div>
  </InputAppButton>
</template>
